// extracted by mini-css-extract-plugin
export default {"group":"WLxE+MSHpN"};
    if(module.hot) {
      // 1648553832933
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  